"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToLaunchYourKitchenOnline() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent) => {
    if (window.innerWidth < 1024) return;
    const {
      clientX,
      clientY
    } = e;
    const moveX = (clientX - window.innerWidth / 2) / 50;
    const moveY = (clientY - window.innerHeight / 2) / 50;
    setMousePos({
      x: moveX,
      y: moveY
    });
  };
  const headingText = "Pronto per il Livello Successivo?";
  const descriptionText = "Unisciti all'élite della mobilità internazionale con soluzioni su misura per la tua carriera e il tuo futuro globale.";
  return <section data-section-id="224590" id="inizia-il-tuo-percorso" onMouseMove={handleMouseMove} className="dark bg-[var(--card)]/80 backdrop-blur-[12px] border-y border-white/10 text-foreground relative overflow-hidden py-32 md:py-48 flex items-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[1200px] opacity-60" style={{
        animation: "gradientShift 12s ease-in-out infinite"
      }}>
          <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] rounded-lg bg-primary/20 blur-3xl mix-blend-screen" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-3xl mix-blend-screen" />
          <div className="absolute top-[20%] left-[30%] w-[40%] h-[40%] rounded-lg bg-primary/15 blur-3xl mix-blend-screen" />
        </div>
      </div>

      {}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[40%] max-w-[500px] hidden lg:block pointer-events-none z-10 transition-transform duration-300 ease-out" style={{
      transform: `translateY(-50%) translate(${mousePos.x}px, ${mousePos.y}px)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/immagine_circolare_ritagliata.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/immagine_circolare_ritagliata.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/immagine_circolare_ritagliata.png-wvc-sizes" alt="World Immigration Delgado Premium Seal" className="w-full h-auto object-contain opacity-80 drop-shadow-3xl rounded-lg" style={{
        animation: "sealEnhanced 12s linear infinite"
      }} loading="lazy" />
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 relative z-20">
        <div ref={ref} className={`max-w-4xl mx-auto lg:mx-0 lg:max-w-2xl text-center lg:text-left p-8 md:p-12 rounded-lg relative transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[50px]"}`} style={{
        background: "linear-gradient(to bottom right, rgba(26, 26, 46, 0.5), rgba(10, 10, 15, 0.8))",
        border: "2px solid transparent",
        backgroundImage: "linear-gradient(rgba(26, 26, 46, 0.8), rgba(26, 26, 46, 0.8)), conic-gradient(from 0deg, #00F5FF, #FF00E5, #00F5FF)",
        backgroundOrigin: "border-box",
        backgroundClip: "padding-box, border-box",
        animation: "gradientBorder 3s linear infinite"
      }}>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-white mb-6 leading-[1.1] flex flex-wrap justify-center lg:justify-start gap-x-4">
            {headingText.split(" ").map((word, i) => <span key={i} data-index={i} className={`transition-all duration-300 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                {word}
              </span>)}
          </h2>

          <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-xl mx-auto lg:mx-0 flex flex-wrap justify-center lg:justify-start gap-x-2">
            {descriptionText.split(" ").map((word, i) => <span key={i} data-index={i} className={`transition-all duration-300 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: `${(headingText.split(" ").length + i) * 100}ms`
          }}>
                {word}
              </span>)}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start">
            <Button asChild size="lg" className="h-16 px-10 text-xl rounded-lg bg-[#FFC829] text-primary hover:bg-[#FFC829]/90 shadow-lg hover:shadow-[var(--glow-cyan)] transition-all duration-300 hover:scale-105 font-default">
              <Link to="/CompanyServicesPage">
                Consulenza Aziendale
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-16 px-10 text-xl rounded-lg border-[#FF00E5] bg-[#FFC829] text-primary hover:bg-[#FFC829]/90 shadow-lg hover:shadow-[var(--glow-magenta)] transition-all duration-300 hover:scale-105 font-default">
              <Link to="/ContactsPage">
                Valutazione Profilo
              </Link>
            </Button>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes sealEnhanced {
            0% { transform: rotate(0deg) scale(1); }
            50% { transform: rotate(180deg) scale(1.08); }
            100% { transform: rotate(360deg) scale(1); }
          }
          @keyframes gradientShift {
            0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.6; }
            50% { transform: translate(-48%, -52%) scale(1.1); opacity: 0.8; }
          }
          @keyframes gradientBorder {
            to { background-position: 200% center; }
            from { filter: hue-rotate(0deg); }
            to { filter: hue-rotate(360deg); }
          }
        `
    }} />
    </section>;
}